import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiinternatinal() {



    const cardData = {

keyword: "Pune to Mumbai International Airport Cab",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable Pune to Mumbai International Airport Cab service for timely airport transfers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and premium vehicles with experienced chauffeurs for smooth intercity highway travel via Mumbai–Pune Expressway. With doorstep pickup across Pune, real-time scheduling support, 24/7 availability, one-way and round-trip options, flight monitoring, and transparent pricing, we ensure a stress-free and punctual journey to Chhatrapati Shivaji Maharaj International Airport, Mumbai.",

topPlaces: [
    {
        title: "Mumbai International Airport (T2 Terminal)",
        description:
            "Chhatrapati Shivaji Maharaj International Airport Terminal 2 is one of India’s busiest international airports, handling global flights and premium airline services. It features modern facilities, lounges, shopping areas, and smooth passenger services, making it a key hub for international travel from Pune via cab transfer."
    },
    {
        title: "Mumbai Airport Terminal 1 (Domestic Terminal)",
        description:
            "Terminal 1 at Mumbai Airport handles domestic flights across India. It is well-connected with airlines operating frequent routes. Pune to Mumbai airport cab service ensures timely arrival at the correct terminal for smooth check-in and boarding experience."
    },
    {
        title: "Mumbai–Pune Expressway Route",
        description:
            "The Mumbai–Pune Expressway is the fastest and safest highway connecting Pune and Mumbai Airport. It offers smooth driving conditions, scenic mountain views, food stops, and minimal travel interruptions, making it ideal for comfortable long-distance airport transfers."
    },
    {
        title: "Lonavala & Khandala Stretch",
        description:
            "Lonavala and Khandala lie on the route between Pune and Mumbai Airport and are known for hills, valleys, and scenic monsoon views. Many travelers enjoy this scenic drive while heading for flights, making the journey more relaxing and enjoyable."
    },
    {
        title: "Panvel & Navi Mumbai Corridor",
        description:
            "Panvel and Navi Mumbai serve as major connectivity points before reaching Mumbai Airport. This route section includes highways, urban roads, and business hubs, ensuring smooth access to the airport from Pune via cab services."
    },
    {
        title: "Khalapur Toll & Food Stops",
        description:
            "Khalapur is a common stop on the expressway known for food courts and rest areas. Travelers often take short breaks here during Pune to Mumbai Airport cab journeys for refreshments and relaxation before continuing their trip."
    },
    {
        title: "Mumbai City Entry Points",
        description:
            "The entry into Mumbai city includes key junctions and traffic zones leading toward the airport. Professional drivers ensure timely navigation through these routes to avoid delays and ensure punctual airport arrival."
    },
    {
        title: "Corporate & Business Travel Zone",
        description:
            "Mumbai Airport serves as a major hub for corporate and business travelers. Pune to Mumbai cab service is widely used by professionals, executives, and VIP clients requiring reliable and punctual intercity airport transfers."
    },
    {
        title: "Hotel & Transit Connections Near Airport",
        description:
            "The airport area includes numerous hotels and transit accommodations for travelers with layovers or early flights. Cab services ensure smooth drop-offs for passengers connecting to hotels near Terminal 2 or Terminal 1."
    },
    {
        title: "Pune Pickup Zones (Hinjewadi, Kharadi, Viman Nagar)",
        description:
            "Major pickup locations in Pune include Hinjewadi IT Park, Kharadi, Viman Nagar, Koregaon Park, and PCMC. These areas are well-connected for fast airport transfers ensuring timely departure to Mumbai International Airport."
    }
],



services: [
{
name: "Pune to Mumbai International Airport Cab",
description: "Rising Cab Service offers Pune to Mumbai International Airport Cab for safe, punctual, and comfortable airport transfers. Our service is designed for hassle-free travel with experienced drivers, clean AC vehicles, and 24x7 availability. Whether you are traveling for business or leisure, we ensure on-time pickup from Pune and smooth drop at Chhatrapati Shivaji Maharaj International Airport (CSMIA) with complete luggage assistance and highway comfort."
},
{
name: "Pune to Mumbai Airport",
description: "Book Pune to Mumbai Airport cab service with Rising Cab Service for reliable intercity airport transfers. We provide well-maintained sedans, SUVs, and premium vehicles to ensure a stress-free journey. Our professional chauffeurs follow timely schedules so you never miss your flight, offering door-to-door pickup and drop service at all terminals."
},
{
name: "Mumbai International Airport to Pune Cab",
description: "Rising Cab Service provides Mumbai International Airport to Pune Cab for comfortable and safe return transfers. Our drivers track flight timings for timely pickup, ensuring smooth travel from airport to Pune city or PCMC. Enjoy AC comfort, professional service, and 24x7 availability for all arrivals."
},
{
name: "Mumbai International Airport to Pune Cab Service",
description: "Book Mumbai International Airport to Pune Cab Service for reliable airport-to-city transportation. We offer fixed pricing, clean vehicles, and experienced chauffeurs for a smooth journey from CSMIA to Pune, Hinjewadi, Kharadi, or any location in the region."
},
{
name: "Pune to Mumbai Domestic Airport Cab",
description: "Rising Cab Service offers Pune to Mumbai Domestic Airport Cab for convenient travel to T1 terminal. Our service ensures timely pickup, comfortable seating, and safe highway driving, making it ideal for business travelers and families."
},
{
name: "Taxi from Mumbai International Airport to Pune",
description: "Book Taxi from Mumbai International Airport to Pune for quick and reliable airport transfers. We provide 24x7 cab availability, professional drivers, and comfortable vehicles to ensure a smooth journey from airport to Pune city and nearby areas."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Rising Cab Service provides Pune to Mumbai Airport Cab with affordable pricing and premium comfort. Our fleet includes sedans, SUVs, Innova Crysta, and more for safe and timely airport transfers with door-to-door service."
},
{
name: "Pune to Mumbai International Airport Cab Service",
description: "Book Pune to Mumbai International Airport Cab Service for hassle-free travel with guaranteed punctuality. Our experienced drivers ensure smooth highway rides and timely arrival at the airport, suitable for all flight schedules."
},
{
name: "Pune to Mumbai Airport Taxi",
description: "Rising Cab Service offers Pune to Mumbai Airport Taxi for safe, clean, and reliable transportation. Enjoy fixed fares, AC comfort, and professional chauffeurs for a stress-free airport journey."
},
{
name: "Pune Airport to Mumbai Airport Cab",
description: "Book Pune Airport to Mumbai Airport Cab for inter-airport transfers with comfort and reliability. Our service ensures smooth connectivity between Pune and Mumbai aviation hubs with timely pickups and drop-offs."
},
{
name: "Pune to Mumbai Airport Taxi Service",
description: "Rising Cab Service provides Pune to Mumbai Airport Taxi Service with 24x7 availability, professional drivers, and well-maintained vehicles for safe and comfortable airport travel."
},
{
name: "Mumbai Airport Cab from Pune",
description: "Book Mumbai Airport Cab from Pune for direct and hassle-free airport transfers. Our service ensures punctual arrival at all terminals with clean vehicles and experienced chauffeurs."
},
{
name: "Pune to Mumbai Airport One Way Cab",
description: "Rising Cab Service offers Pune to Mumbai Airport One Way Cab for affordable drop-only travel. Ideal for solo travelers, families, and business passengers looking for budget-friendly airport transport."
},
{
name: "Pune to Mumbai Airport Drop Taxi",
description: "Book Pune to Mumbai Airport Drop Taxi for convenient and timely airport drop service. Enjoy door-to-door pickup, AC comfort, and professional drivers ensuring stress-free travel."
},
{
name: "Pune to Mumbai Airport Transfer Service",
description: "Rising Cab Service provides Pune to Mumbai Airport Transfer Service for reliable and safe airport connectivity. We ensure smooth rides, fixed pricing, and punctual service for all passengers."
},
{
name: "Pune to Chhatrapati Shivaji Maharaj International Airport Cab",
description: "Book Pune to Chhatrapati Shivaji Maharaj International Airport Cab for premium airport transfers. Our service guarantees safe driving, comfortable seating, and timely arrival at Mumbai’s main international airport."
},
{
name: "Pune to Mumbai T2 Airport Cab",
description: "Rising Cab Service offers Pune to Mumbai T2 Airport Cab for Terminal 2 passengers. Enjoy smooth highway travel, AC comfort, and professional drivers for on-time arrivals."
},
{
name: "Pune to Mumbai Terminal 2 Cab",
description: "Book Pune to Mumbai Terminal 2 Cab for reliable and direct airport transportation. We ensure hassle-free travel to international departures and arrivals at T2."
},
{
name: "Pune to Mumbai T1 Airport Cab",
description: "Rising Cab Service provides Pune to Mumbai T1 Airport Cab for domestic terminal travel. Our service ensures punctual pickup and comfortable journey for all passengers."
},
{
name: "Pune to CSMIA Airport Cab",
description: "Book Pune to CSMIA Airport Cab for safe and reliable travel to Chhatrapati Shivaji Maharaj International Airport. We offer 24x7 service with professional chauffeurs."
},
{
name: "Pune to Mumbai International Terminal Cab",
description: "Rising Cab Service offers Pune to Mumbai International Terminal Cab for smooth airport connectivity with timely service and comfortable vehicles."
},
{
name: "Pune to Mumbai Domestic Airport Cab",
description: "Book Pune to Mumbai Domestic Airport Cab for T1 terminal transfers with safe driving, AC comfort, and affordable pricing."
},
{
name: "Pune to Mumbai Airport Shuttle Service",
description: "Rising Cab Service provides Pune to Mumbai Airport Shuttle Service for shared or private airport transfers with reliable scheduling and professional drivers."
},
{
name: "Pune to Mumbai Airport Transportation",
description: "Book Pune to Mumbai Airport Transportation for complete travel solutions including sedans, SUVs, and premium cabs for airport connectivity."
},
{
name: "Pune to Mumbai Airport Innova Crysta Cab",
description: "Rising Cab Service offers Pune to Mumbai Airport Innova Crysta Cab for premium comfort, spacious seating, and smooth highway travel ideal for families and business travelers."
},
{
name: "Pune to Mumbai Airport Ertiga Cab",
description: "Book Pune to Mumbai Airport Ertiga Cab for affordable 7-seater travel with comfort, AC convenience, and professional drivers."
},
{
name: "Pune to Mumbai Airport Sedan Cab",
description: "Rising Cab Service provides Pune to Mumbai Airport Sedan Cab for budget-friendly and comfortable airport transfers with smooth rides."
},
{
name: "Pune to Mumbai Airport Swift Dzire Cab",
description: "Book Pune to Mumbai Airport Swift Dzire Cab for economical and reliable airport travel with clean vehicles and experienced chauffeurs."
},
{
name: "Pune to Mumbai Airport SUV Cab",
description: "Rising Cab Service offers Pune to Mumbai Airport SUV Cab for spacious and comfortable group travel with premium vehicles and safe driving."
}
],

tableData: [
["Pune to Mumbai Airport Cab","Pune to Mumbai International Airport Cab"],
["Mumbai International Airport to Pune Cab","Pune to Mumbai Airport Taxi"],
["Pune to Mumbai Airport One Way Cab","Pune to Mumbai Airport Drop Taxi"],
["Pune to Mumbai Airport Transfer Service","Pune to Mumbai Airport Taxi Service"],
["Pune to Mumbai T2 Airport Cab","Pune to Mumbai T1 Airport Cab"],
["Pune to Mumbai Airport Innova Crysta Cab","Pune to Mumbai Airport SUV Cab"],
["Pune to CSMIA Airport Cab","Mumbai Airport Cab from Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Mumbai International Airport Cab Service",
        WhyChoosedescription: "Rising Cab Service offers comfortable Pune to Mumbai International Airport cab transportation for business travelers, families, tourists, students, and frequent flyers."
    },
    {
        WhyChooseheading: "24/7 Airport Transfer Availability",
        WhyChoosedescription: "Our airport cab services are available round the clock, ensuring hassle-free travel for early morning departures, late-night flights, and emergency airport transfers."
    },
    {
        WhyChooseheading: "Direct Drop to Mumbai International Airport",
        WhyChoosedescription: "Enjoy convenient door-to-door transportation from Pune directly to Chhatrapati Shivaji Maharaj International Airport without the stress of changing vehicles."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Travel Need",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Rumion, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers according to passenger and luggage requirements."
    },
    {
        WhyChooseheading: "Ideal for Business and Family Travel",
        WhyChoosedescription: "Our airport transfer services are preferred by corporate executives, families, tourists, international travelers, and group passengers."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Cab pickups are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and surrounding locations."
    },
    {
        WhyChooseheading: "Professional Drivers and On-Time Service",
        WhyChoosedescription: "Experienced drivers ensure timely pickups, route expertise, safe driving, and comfortable travel to the airport."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Options",
        WhyChoosedescription: "Customers can choose one-way airport drops, return airport pickups, and customized travel packages according to their schedules."
    }
]
};

const faqData = [
    {
        question: "Do you provide Pune to Mumbai International Airport cab service?",
        answer: "Yes, Rising Cab Service offers direct cab transportation from Pune to Mumbai International Airport throughout the year."
    },
    {
        question: "Is the airport cab service available 24/7?",
        answer: "Yes, airport transfer services are available day and night to match all flight schedules."
    },
    {
        question: "Which vehicles are available for airport transfers?",
        answer: "Sedan cars, Ertiga, Rumion, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers are available."
    },
    {
        question: "Can I book a one-way cab to Mumbai Airport?",
        answer: "Yes, one-way airport drop services are available from Pune and PCMC."
    },
    {
        question: "Can families book larger vehicles for airport travel?",
        answer: "Yes, spacious vehicles like Innova Crysta, Kia Carens, Rumion, and Tempo Travellers are available for families and groups."
    },
    {
        question: "Do you provide airport pickups from Mumbai International Airport to Pune?",
        answer: "Yes, return airport pickup services from Mumbai Airport to Pune are also available."
    },
    {
        question: "Can corporate travelers book airport cabs?",
        answer: "Yes, our airport cab services are widely used by corporate professionals and business travelers."
    },
    {
        question: "Is advance booking recommended for airport transfers?",
        answer: "Yes, advance booking helps ensure vehicle availability and timely travel arrangements."
    },
    {
        question: "Do you provide pickups from all Pune locations?",
        answer: "Yes, pickups are available from residential areas, hotels, offices, Pune Railway Station, and Pune Airport."
    },
    {
        question: "How can I book a Pune to Mumbai International Airport Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Harshal Joshi",
        feedback:
            "I regularly travel internationally for business and always book airport transfers with Rising Cab Service. The driver arrived on time and the journey was smooth and comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Kulkarni",
        feedback:
            "Our family needed a comfortable ride to Mumbai International Airport with multiple bags. The vehicle was spacious, clean, and the service was excellent from pickup to drop-off.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Mumbai International Airport Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-mumbai-airport-cab.jpg",
"description": "Book Pune to Mumbai International Airport Cab Service with Rising Cab Service for reliable airport transfers. Comfortable AC sedans, SUVs, and Innova Crysta available for safe pickup and drop between Pune and Mumbai Airport.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹2999",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-mumbai-international-airport-cab"
}
};







    return (
        <div>
<Helmet>
  <title>Pune to Mumbai International Airport Cab | Airport Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Mumbai International Airport Cab for safe and reliable airport transfers. Get AC sedans, SUVs, and Innova Crysta for comfortable travel between Pune and Mumbai Airport."
/>

<meta
 name="keywords"
 content="pune to mumbai international airport cab, pune to mumbai airport taxi, mumbai airport to pune cab, pune airport to mumbai airport cab, pune to mumbai domestic airport cab, mumbai airport cab from pune, pune to mumbai airport cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiinternatinal;